import { combineReducers, configureStore } from "@reduxjs/toolkit";
import commonSlice from "store/commonStore/commonStore";
import { consoleSettingSlice } from "./features/consoleSettingSlice";
import mapSlice from "./features/mapSlice";
import RequestTaxiStore from "./features/RequestTaxiSlice";

const rootReducer = combineReducers({
  consoleSettingStore: consoleSettingSlice.reducer,
  mapStore: mapSlice.reducer,
  requestTaxiStore: RequestTaxiStore.reducer,
  commonStore: commonSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RequestState = ReturnType<typeof store.getState>;

export type RequestDispatch = typeof store.dispatch;
